module.exports = __webpack_public_path__ + "static/img/point-font-img@m.bc4e99e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/point-font-img@m.png
// module id = S+dk
// module chunks = 0